import React, { useState, useRef, useEffect } from 'react';
import './style.css';


const NodeEditOptions = ({ onDelete, onPreview }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  
  const toggleMenu = () => setIsOpen(!isOpen);
  
  const handleDelete = () => {
    onDelete();
    setIsOpen(false);
  };
    
  const handlePreview = () => {
    onPreview();
    setIsOpen(false);
  };
  
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  return (
    <div className="options-container" ref={menuRef}>
      <button className="three-dots-button" onClick={toggleMenu}>⋮</button>
      
      {isOpen && (
        <div className="dropdown-menu">
          <button className="menu-item" onClick={handlePreview}>
            👁️ Preview
          </button>
          <button className="menu-item delete" onClick={handleDelete}>
            🗑️ Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default NodeEditOptions; 